import OwnerController from "../owner_controller";
import { GROUP_REPORT_PACKAGE_BY_DAY, GROUP_REPORT_PACKAGE_BY_HOUR, OWNER_REPORT_PACKAGE_BY_DAY, OWNER_REPORT_PACKAGE_BY_HOUR } from "../../routes";

export default class extends OwnerController {
  initialize() {
    this.fetch();
  }

  async fetch() {
    this.setEmpty(this);
    this.setLoading(this);
    const { data } = await this.axios.get(this.packageReportUrl, {
      params: this.filter.dataFilter
    });
    this.processPartial(data);
  }

  get packageReportUrl() {
    if(this.filter.restaurantGroupId == null) {
      if (this.filter.isByHour == true) return OWNER_REPORT_PACKAGE_BY_HOUR;
      return OWNER_REPORT_PACKAGE_BY_DAY;
    }
    if (this.filter.isByHour == true) return GROUP_REPORT_PACKAGE_BY_HOUR;
    return GROUP_REPORT_PACKAGE_BY_DAY;
  }
}
